import { yup } from '@framework/validation';
import { CommonBaseWidgetSchema } from '../../../CommonBaseWidgetSchema';
import { WidgetType } from '../../../Widget';
import { uniqueWidgetCodeSchema } from '../../../validation/uniqueWidgetCodeSchema';
import { IconType } from '../buttons/icons/Icons';
import { ButtonAlign, ButtonType } from '../buttons/types/ButtonEnums';
import { IConfirmWidget } from './IConfirmWidget';

export const ConfirmWidgetSchema = CommonBaseWidgetSchema.shape({
  code: uniqueWidgetCodeSchema,
  type: yup.string().required().exact(WidgetType.Confirm).label('Tipo'),
  layout: yup.object({
    confirmIcon: yup
      .string()
      .oneOfEnum(IconType)
      .default(IconType.Nessuna)
      .optional()
      .label('Icona pulsante di conferma'),
    confirmText: yup.string().default('Conferma'),
    confirmButtonType: yup
      .string()
      .oneOfEnum(ButtonType)
      .default(ButtonType.Primary)
      .optional()
      .label('Tipo pulsante di conferma'),

    editIcon: yup
      .string()
      .oneOfEnum(IconType)
      .default(IconType.Nessuna)
      .optional()
      .label('Icona pulsante di modifica'),
    editText: yup.string().default('Modifica'),
    editButtonType: yup
      .string()
      .oneOfEnum(ButtonType)
      .default(ButtonType.Primary)
      .optional()
      .label('Tipo pulsante di modifica'),
    alignEnd: yup.boolean().default(false),

    buttonsAlign: yup
      .string()
      .oneOfEnum(ButtonAlign)
      .default(ButtonAlign.End)
      .optional()
      .label('Allineamento pulsante'),
  }),
})
  .required()
  .noUnknown() satisfies yup.ObjectSchema<IConfirmWidget>;
